module.exports = __webpack_public_path__ + "static/img/logo.648feb4e.png";